import { Action } from 'redux';

import { DeleteLabelValue } from '~src/bootstrap/redux/actions/AppActionTypes';
import { ILabelValueInfo } from '~src/catalog/models/ILabelValueInfo';

export interface DeleteLabelValueAction extends Action {
  item: ILabelValueInfo;
}

export function deleteLabelValueAction(item: ILabelValueInfo): DeleteLabelValueAction {
  return {
    type: DeleteLabelValue,
    item
  };
}
